import { useState } from "react";

export default function useController() {
  const [slides, setSlides] = useState([]);
  const [initialCard, setInitialCard] = useState({});
  const [currentSlideCount, setCurrentSlideCount] = useState(1);

  const onPayloadHandle = ({ cards, card }) => {
    setInitialCard(card);
    setSlides(cards);
    setCurrentSlideCount(card.id + 1);
  };
  const onSwipeChange = (swiper) => {
    setCurrentSlideCount(swiper.activeIndex + 1);
  };

  return {
    onPayloadHandle,
    onSwipeChange,
    slides,
    initialCard,
    currentSlideCount,
    onSelectSlide: (card) =>
      setSlides((prevState) =>
        prevState.map((item) => ({
          ...item,
          isCheckedZone:
            item.id === card.id ? !item.isCheckedZone : item.isCheckedZone,
        }))
      ),
  };
}
